// Presentation only: source identifiers remain intact for reconciliation and audit.
export const displayImportedText = value => typeof value === 'string'
  ? value.replace(/GEDIP-/gi, 'IMP-').replace(/GedipBioImp2/gi, 'Sibilla BIA').replace(/GEDIP4?/gi, 'archivio precedente')
  : value;
export const displayMethod = value => ({
  'GedipBioImp2-6109-unified-1': 'Sibilla BIA · versione 1',
  'Gedip4-controllo-antropometrico': 'Controllo antropometrico importato',
  'gedip-original-context-1': 'Dati originali importati',
  'gedip-incomplete-context-1': 'Dati importati incompleti',
  'patient-at-acquisition-1': 'Dati registrati all’acquisizione'
}[value] || displayImportedText(value) || 'Non disponibile');
